import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CardapioMinishopProdutoDTO } from '../../../../../models/cardapio-minishop/cardapio-minishop.model';

@Component({
  selector: 'app-cardapio-minishop-produto-item',
  templateUrl: './cardapio-minishop-produto-item.component.html',
  styleUrls: ['./cardapio-minishop-produto-item.component.scss'],
})
export class CardapioMinishopProdutoItemComponent implements OnInit, OnDestroy {
  @Input() produto!: CardapioMinishopProdutoDTO;
  @Input() moedaSimbolo = 'BRL';
  @Input() moedaLocal = 'pt-BR';

  @Output() editar = new EventEmitter<CardapioMinishopProdutoDTO>();
  @Output() toggleVisibilidade = new EventEmitter<CardapioMinishopProdutoDTO>();
  @Output() excluir = new EventEmitter<number>();

  menuItems: MenuItem[] = [];

  texts = {
    variantes: '',
    editar: '',
    excluir: '',
    visivel: '',
    oculto: '',
  };

  private langChangeSub!: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
      this.buildMenu();
    });
    this.buildMenu();
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) this.langChangeSub.unsubscribe();
  }

  get variantesLabel(): string | null {
    const count = this.produto.variantes?.length || 0;
    if (count === 0) return null;
    return `${count} ${this.texts.variantes}`;
  }

  get visibilidadeIcon(): string {
    return this.produto.visivel ? 'pi pi-eye' : 'pi pi-eye-slash';
  }

  get visibilidadeTooltip(): string {
    return this.produto.visivel ? this.texts.visivel : this.texts.oculto;
  }

  private buildMenu(): void {
    this.menuItems = [
      {
        label: this.texts.editar,
        icon: 'pi pi-pencil',
        command: () => this.editar.emit(this.produto),
      },
      { separator: true },
      {
        label: this.texts.excluir,
        icon: 'pi pi-trash',
        styleClass: 'text-red-500',
        command: () => this.excluir.emit(this.produto.id!),
      },
    ];
  }

  private loadTranslations(): void {
    this.texts = {
      variantes: this.translate.instant('cardapio_minishop.produto.variantes'),
      editar: this.translate.instant('cardapio_minishop.comum.editar'),
      excluir: this.translate.instant('cardapio_minishop.comum.excluir'),
      visivel: this.translate.instant('cardapio_minishop.produto.visivel'),
      oculto: this.translate.instant('cardapio_minishop.produto.oculto'),
    };
  }
}
